var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2MultifilarAssistedDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 29h-5v-4h29v4h-5v9h-4v-9H36v9h-4v-9zm9.4 13.46l6.6 5.6V56h4v-9.81l-8.09-6.8-2.51 3.07zM33 56h4v-9.81l-8.09-6.8-2.51 3.07 6.6 5.6V56zm37-41v49H6V29.22L19.57 15H70zm-4 4H21v12H10v29h56V19z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Multifilar_Assisted_Diagram.594321db.svg";
export { SvgA2MultifilarAssistedDiagram as ReactComponent };